import React from 'react';
import Section from "./components/Section";
import {lightGradient} from "./Helpers";
import Media from "react-media";
import {MD_BREAKPOINT} from "../../../Constants/Constants";
import Posed from 'react-pose';
import Carousel from "./components/Carousel";
class Projects extends Section {

	constructor(props) {
		super(props);
		//console.log("About Constructor", props);
		this.aboutRef = React.createRef();
	}

	componentDidMount() {
		this.props.updateRef(this.props.title, this.aboutRef);
	}

	styles = {
		...Section.styles,
		mainContainer: {
			...Section.styles.mainContainer,
			// background: "url(" + IMAGES_DIR + "/home.jpg)",
			// backgroundSize: "cover",
			backgroundImage: (this.props.backgroundColor ? lightGradient(this.props.backgroundColor) : "#fff"),
			backgroundAttachment: 'fixed',
			textAlign: "center",

		},
		contentContainer: {
			...Section.styles.contentContainer,
			padding: "auto",
			// minHeight: "100vh",
			display: "flex",
			flexDirection: "column",
			// alignContent: "center",
			justifyContent: "space-between",
			// alignItems: "center",
			fontSize: "1rem",
			lineHeight: '1.15rem',
		},
		title: {
			...Section.styles.title,
			fontStyle: "bold",
			textAlign: "center",
		},
		subTitle: {
			...Section.styles.subTitle,
			fontSize: "1.15rem",
			lineHeight: "1.25rem",
		},
		listItem: {
			...Section.styles.listItem,

		}
	};

	render() {
		return (
			<div style={this.styles.mainContainer} ref={this.aboutRef}>
				<div style={this.styles.contentContainer}>
					<h1 style={this.styles.title}>{this.props.title}</h1>
					{this.props.subtitle ? <h2 style={this.styles.subTitle}>{this.props.subtitle}</h2> : null}
					<div style={{ padding:"1rem"}} className="d-flex flex-wrap justify-content-around">
					{/* <Carousel items={this.props.data} styles={this.styles}/> */}
					{
						this.props.data.map((item, index) => (
							<CommonListItem 
								key={index} 
								styles={this.styles} 
								{...item} 
								window_height={this.props.window_height}
								window_width={this.props.window_width}
								backgroundThemeColor={this.props.backgroundColor}
							/>
						))
					}

					</div>
				</div>
			</div>
		);
	}
}

export const ListItemPose = Posed.div({
	enter: { y: 0, opacity: 1 },
	exit: { y: 50, opacity: 0 },
	transition: {
		type: 'spring'
	}
});

export class CommonListItem extends React.Component {
	
	constructor(props){
		super(props);
		this.state={hover: false, ref: React.createRef()}
	}

	componentDidMount(){
		// console.log(this.state.ref.current);
	}

	render(){
		const {props} = this;
		//console.log(props);
		const title = (
			<div 
				key="title" 
				style={{
					...props.styles.subTitle,
					fontSize:'1.25rem',
					lineHeight: '1.5rem'
				}}
			>
				{props.title}
			</div>
		);

		const subtitle = (
			<div 
				key="subtitle" 
				style={{
					...props.styles.subTitle,
					fontSize:'1.25rem',
					lineHeight: '1.5rem',
					fontStyle: 'italic'
				}}
			>
				{props.subTitle}
			</div>
		);

		const description = null;
		// (
		// 	<ul key="description" style={{textAlign: "justify", marginTop: "1rem"}}>
		// 		{props.description.map((item, index)=><li key={index}>{item}</li>)}
		// 	</ul>
		// );
		// console.log(url(props.imgSrc))
		const screenshot = (
			<img src={props.imgSrc} height="300px" width="400px"/>
		)


		return (
			<ListItemPose>
				
					<div
						style={{
							...props.styles.contentContainer, 
							paddingBottom: "20vmin",
							// paddingBottom: this.state.hover ? "20vmin" : "15vmin", 
							color: "white", 
							fontSize: "1em",
							transition: '0.1s ease-in-out',
						}}>
							<a 	
								className="text-decoration-none"
								ref={this.state.ref}
								href={props.link_url} 
								target="_blank" 
							>
								<div
									// className={this.state.hover ? "blur" : ""}
									onMouseEnter={(e)=>{
										this.setState({hover: true})
									}} 
									onMouseLeave={(e)=>{							
										this.setState({hover: false})
									}} 
									onClick={(e) => {
										console.log(props.title);
										// window.open(props.link_url, "_blank");
									}}
									style={{
										boxShadow: this.state.hover ? 'none' : '0px 2px 20px 0px darkslategrey',
										borderRadius:'0.25rem',
										position: 'relative',
										display: 'flex', 
										flexDirection: "column", 
										height: this.props.window_width <= MD_BREAKPOINT ? '180px' : '210px',
										// width: '100%',
										width: this.props.window_width <= MD_BREAKPOINT ? '300px' : '350px',
										minWidth: "300px",
										// width: '320px',
										background: `url(${props.imgSrc}), linear-gradient(to bottom right, white, #eee)`,
										backgroundRepeat: 'no-repeat',
										zIndex: this.state.hover ? 100 : 0,
										backgroundSize: 'cover',
										backgroundPosition: 'center',
										// transform: this.state.hover ? "scale(1.2)" : "scale(1)",
										transition: '0.2s ease-in-out',
										margin: '1rem',
									}} 
								>
								<div
									// className="no-blur"
									style={{
										textAlign: 'center',
										borderRadius:'0.25rem',
										height: "100%",
										// width: "100%",
										// backgroundColor: this.state.hover ? 'rgba(38, 49, 55, 0.9)' : null,
										color: this.state.hover ? "#003f00" : "#001000",
										padding: "0.5rem",
										zIndex: 2,
										display: 'flex', 
										flexDirection: "column", 
										justifyContent: 'center',
										alignItems: 'center',
										// height: '360px', 
										// width: '640px',
										position: 'relative',
									}} 
								>
									<div 
										style={{	
											position: 'absolute',
											// top: this.state.hover ? '20%' : '0' ,									
											top: '105%',
											// bottom: '-30%',
											// display: this.state.hover ? 'block' : 'none',
											transition: '0.5s ease-in-out',
											// background: 'rgba(0, 0, 0, 0.75)'										
											fontWeight: '300',
										}}
									>
										{
											[title, subtitle, description]
										}
									</div>
								</div>
							</div>
						</a>
					</div>
		</ListItemPose>
		);
	};
}

export default Projects;
{/* <Media query={`max-width: ${MD_BREAKPOINT}`}>
						{
							matches => matches ?
								(
									<div style={{display: 'flex', flexDirection: "column"}}>
										{[title, subtitle, description]}
									</div>
								)
								:
								(
									<div style={{display: 'flex', flexDirection: "column"}}>
										<div style={{display: 'flex', flexDirection: "row", justifyContent: "space-between"}}>
											{[title, subtitle]}
										</div>
										{description}
									</div>
								)
						}
					</Media> */}